import React, {useContext, useEffect, Suspense, lazy} from 'react'
import { Routes, Route} from 'react-router-dom'
import FrontendLayout from "./FrontendLayout"
import RootContext from '../context/RootContext'
import Loader from '../Loader/Loader'
import OnlineAdmission from '../views/Home/OnlineAdmission'
import PDFView from '../views/PDFView'
import AdmissionProcess from '../views/AdmissionProcess'
import AdmitCard from '../views/AdmitCard'
import ApplicantForm from '../views/ApplicantForm'
import Contact from '../views/Contact'

const Error404 = lazy( () => import('../errors/Error404'))

const AppRoutes = () => {
  const {loading, setLoading } =  useContext(RootContext)
  useEffect( () => {
    setLoading(false);
  },[setLoading])

  return loading ? <Loader /> : (
    <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/*" element={<FrontendLayout />}>
              <Route index element={<OnlineAdmission />}/>
              <Route path="apply/:programId/:programName/:admissionSemesterUID/:semester" element={<ApplicantForm />} />
              <Route path='admission-process' element={<AdmissionProcess />}/>
              <Route path='admit-card' element={<AdmitCard />}/>
              <Route path='contact' element={<Contact />}/>
              <Route path="view-pdf/:id" element={<PDFView />}/>
              <Route path="*" element={<Error404 />} />
          </Route>
        </Routes>
   
  </Suspense>
  )
}
export default AppRoutes